<template>
  <div
    v-if="dialogValue"
    class="attr-dialog"
    :class="{ global: global }"
  >
    <common-header slot="title" title="模板配置" @goHome="onCloseDialog">
      <div slot="right" class="btn-tools">
        <missing-font-modal
          v-show="missingFontShow"
          v-model="missingFontVisible"
          :data="missingFontFamilyList"
          :tplProjectId="valueData.projectId"
          @onItemClick="onItemClick"
        >
          <el-button type="text" class="text-button mf-button" @click.stop="openMissingFontDialog"><span class="big">A</span>？</el-button>
        </missing-font-modal>
        <el-button
          class="text-button"
          type="text"
          @click="fixedTextLayer"
          v-if="isSYSAdmin"
          title="文本高度异常可用此修复"
          >修复文本</el-button
        >
        <el-button
          class="text-button"
          type="text"
          @click="onReset"
          :loading="resetLoading"
          v-if="valueData.json.originData"
          title="重置模板数据"
          >还原设置</el-button
        >
        <el-button type="default" @click="onCloseDialog">取消</el-button>
        <el-button
          type="primary"
          @click="onConfirmDialog"
          :loading="saveLoading"
          >完成</el-button
        >
      </div>
      <div slot="center" class="center-title">
        <div class="ct-box">
          <p>{{ `${valueData.json.width}x${valueData.json.height}` }}</p>
          <p>{{ valueData.name }}</p>
        </div>
      </div>
    </common-header>
    <common-attr
      :tpl-data="valueData"
      :tpl-modules="moduleList"
      :tree-data="valueData.json.children"
      :loading="saveLoading"
      :global="global"
      @onItemClick="onItemClick"
    >
      <template slot="form" v-if="!global">
        <template-form
          v-if="singleType === valueData.type"
          ref="templateFormRef"
          v-model="valueData"
          :showProject="false"
          labelWidth="115px"
        ></template-form>
        <template-form
          v-else
          ref="templateFormRef"
          short-name="画布组(选填)"
          :short-name-require="false"
          :showProject="false"
          labelWidth="115px"
          v-model="valueData"
        ></template-form>
      </template>
      <template slot="main" slot-scope="slotProps">
        <editor-area
          @click.native="onEditorClick"
          ref="screenshotDom"
          v-model="valueData.json"
          :key="refreshTplKey"
          :itemCover="imgCover"
          :scale="slotProps.scale"
          :edit="false"
          :tplProjectId="valueData.projectId"
          :layer-resize="true"
          @onItemClick="onEditorItemClick"
        ></editor-area>
      </template>
    </common-attr>
    <!-- <missing-font-dialog
      v-model="missingFontVisible"
      :data="missingFontFamilyList"
      :tplProjectId="valueData.projectId"
    ></missing-font-dialog> -->
  </div>
</template>
<script>
import commonAttr from './common-attr'
import editorArea from '../../templateGroup/editor/tpl-editor-area'
import fontService from '../../../request/service/font-service'
import {
  empty_template_group,
  group_type_pt,
  group_type_mk,
  template_type_single,
  template_type_multiple,
  module_group_edit,
  layer_text
} from '@/const.js'
import templateForm from '../../template/form/template-form'
import templateService from '../../../request/service/template-service'
import groupService from '../../../request/service/group-service'
// import missingFontDialog from './missing-font-dialog'
import missingFontModal from './missing-font-modal'
import TUtil from '../../templateGroup/TUtil'
import commonHeader from './common-header'

export default {
  name: 'attrDialog',
  components: {
    commonAttr,
    commonHeader,
    editorArea,
    templateForm,
    // missingFontDialog,
    missingFontModal
  },
  props: {
    value: Boolean,
    data: Object,
    global: Boolean, // true : 表示模块组设置
    isNew: Boolean //是否是刚上传模板后，直接打开的弹框
  },
  data () {
    return {
      valueData: JSON.parse(JSON.stringify(empty_template_group)),
      singleType: template_type_single,
      missingFontVisible: false,
      missingFontFamilyList: [],
      moduleList: [],
      parentMap: {},
      imgCover: null,
      saveLoading: false,
      resetLoading: false,
      refreshTplKey: 0
    }
  },
  computed: {
    dialogValue: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    },
    isSYSAdmin () {
      return this.$store.getters['app/isSYSAdmin']
    },
    isAdminPucTpl () {
      return this.$route.name === 'admin-template-public'
    },
    missingFontShow () {
      return this.missingFontFamilyList && this.missingFontFamilyList.some(item => {
        return item.missingFont
      })
    }
  },
  watch: {
    dialogValue: {
      handler (v) {
        if (v) {
          this.init()
        } else {
          this.$nextTick(() => {
            this.removeEvent()
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    init () {
      this.onOpen()
      this.initData(this.data)
      this.bindEvent()
    },
    initData (data) {
      let newData = TUtil.copyDataToChildren(JSON.parse(JSON.stringify(data)))
      this.valueData = this.deepData(newData)
      if (!this.global) {
        this.$store.dispatch('app/queryTemplateGroup', {
          projectId: this.valueData.projectId,
          type: this.valueData.type
        })
        this.$store.commit('templateGroup/set_attr_tab', '1')
        this.setTplGroupName()
        this.formatterTagNames()
      }
      if (this.isNew) {
        this.$nextTick(() => {
          this.fixedTextLayer()
        })
      }
      this.queryTplFontList()
    },
    fixedTextLayer () {
      this.fixLineHeight()
      this.$message.success('文本高度已经修复')
    },
    fixLineHeight () {
      let itemDom,
        textList,
        fontSize,
        itemMap = {}
      textList = document.querySelectorAll('.selection-text')
      for (let i = 0; i < textList.length; i++) {
        itemDom = textList[i]
        fontSize = +window.getComputedStyle(itemDom).fontSize.replace('px', '')
        // console.log('itemDom', itemDom)
        if (itemDom.dataset.key && fontSize) {
          itemMap[itemDom.dataset.key] = {
            fontSize,
            height: itemDom.offsetHeight,
            top: itemDom.offsetTop
          }
        }
      }
      this.deepDataForFixData(itemMap, this.valueData.json.children)
    },
    deepDataForFixData (itemMap, children) {
      children &&
        children.forEach(item => {
          if (item.children && item.children.length > 0) {
            this.deepDataForFixData(itemMap, item.children)
          } else if (item.type === 'text') {
            this.compareData(itemMap, item)
          }
        })
    },
    compareData (itemMap, textLayer) {
      let styleInfo = itemMap[textLayer.key]
      if (!styleInfo) {
        return
      }
      if (styleInfo.top > 0 && !textLayer.isMoreRow) {
        //高度不对
        textLayer.lineHeight = textLayer.fontSize
      }
    },
    bindEvent () {
      window.addEventListener('keydown', this.onKeydown)
      this.eventBus.$on('onOpenMissingFont', this.openMissingFontDialog)
      this.eventBus.$on('_delModule_attrDialog', this.removeModule)
    },
    removeEvent () {
      window.removeEventListener('keydown', this.onKeydown)
      this.eventBus.$off('onOpenMissingFont', this.openMissingFontDialog)
      this.eventBus.$off('_delModule_attrDialog')
    },
    removeModule (module) {
      this.moduleList = this.moduleList.filter(item => {
        return item !== module
      })
    },
    setTplGroupName () {
      // 未填写分组是，后台默认加了分组，便于排序。显示时，需要把分组置空
      if (this.valueData.tplGroupName.indexOf('DEFAULT_') > -1) {
        this.valueData.tplGroupName = ''
      }
    },
    formatterTagNames () {
      let tags = this.valueData.tags
      if (tags && tags.length > 0) {
        this.valueData.tagNames = tags.map(item => {
          return item.name
        })
      }
    },
    deepData (treeData) {
      let children = treeData.json.children || []
      let result = []
      if (children) {
        this.deepChildren(treeData.json, result)
        this.$store.commit('templateGroup/set_bg_item', this.pageBgItem || null)
      }
      if (this.moduleList.length === 0) {
        this.$store.commit('templateGroup/set_attr_tab', '1')
      }
      // this.openMissingFontDialog();
      // this.getMissingFont();
      return treeData
    },
    deepChildren (parent, dataList) {
      parent.children &&
        parent.children.forEach((item, index) => {
          this.parentMap[item.id] = parent
          dataList.push(item)
          if (!item.originName) {
            item.originName = item.name
          }
          this.setTplFont(item)
          this.addAttr(item)
          if (item.isModuleGroup && !this.data.free) {
            this.moduleList.push(item)
          }
          if (item.children) {
            this.deepChildren(item, dataList)
          }
        })
    },
    addAttr (item) {
      this.setBgItem(item)
    },
    setBgItem (item) {
      let isSingleTpl = this.singleType === this.valueData.type
      if (isSingleTpl) {
        if (item.isBgImg || item.isPageBgImg) {
          this.pageBgItem = item
        }
      } else {
        if (item.isPageBgImg) {
          this.pageBgItem = item
        }
      }
    },
    getFontItem (tplFontName) {
      let { sysFont, projFont, unSetSysFont } = this.$store.state.app.allFontObj
      let fontList = [...unSetSysFont, ...projFont, ...sysFont]
      let idx = fontList.findIndex(item => {
        return item.psName && item.psName === tplFontName // 【逻辑变更】不从mainNames中查找，而是从psName中查找
        // return item.mainNames && item.mainNames.indexOf(tplFontName) > -1
      })
      return idx > -1 ? fontList[idx] : null
    },
    async queryTplFontList () {
      let fontList = this.missingFontFamilyList
      let set = new Set()
      // 开始去重复
      fontList.forEach(item => {
        set.add(item.fontFamily)
      })
      // 更新字体下拉列表
      await this.$store.dispatch('app/queryFontList', {
        projectId: this.valueData.projectId,
        fontNameList: Array.from(set)
      })
      //设置所有文本图层字体缺失状态
      fontList.forEach(item => {
        this.setMissingFont(item)
      })
      this.openMissingFontDialog()
    },
    setTplFont (item) {
      let fontName = item.fontFamily
      if (!fontName) {
        return
      }
      item.missingFont = false // 重置缺失状态，等查询所有字体后再验证是否有字体缺失
      this.missingFontFamilyList.push(item) // 目前是把所有的字体（缺失&未缺失）放到一个数组里，后面再去重
    },
    setMissingFont (item) {
      let fontName = item.fontFamily
      let fontItem = this.getFontItem(fontName)
      if (fontItem) {
        //有可能匹配到多个主名中的一个，但这个主名不是字体下拉列表中的name值，而是mainNames里的值，此处更新成name值
        item.missingFont = false
        // item.fontFamily = fontItem.name 【逻辑变更】不从mainNames中查找，而是从psName中查找，只匹配psName
      } else {
        item.missingFont = true
        this.missingFontFamilyList.push(item)
        console.warn('缺失字体', fontName)
      }
    },
    openMissingFontDialog () {
      let hasMissingFont = this.missingFontFamilyList.some(item => {
        return item.missingFont
      })
      if (hasMissingFont) {
        this.missingFontVisible = true
      }
    },
    async updateTemplate () {
      await this.$refs.templateFormRef._validateForm()
      this.saveLoading = true
      let cloneData = JSON.parse(JSON.stringify(this.valueData))
      if (cloneData.type === template_type_single) {
        delete cloneData.json.data
      }
      let updateCover = true
      // console.log(this.$route.name)
      if (this.$route.name === 'admin-template-public') {
        templateService
          .updateTemplate(cloneData, updateCover)
          .then(() => {
            this.$emit('onSave')
            this.onClosed()
            this.$emit('input', false)
            this.$message.success('保存成功')
            this.resetData()
          })
          .finally(() => {
            this.saveLoading = false
          })
      } else {
        templateService
          .saveTemplatev2(cloneData)
          .then(d => {
            this.$emit('onSave')
            this.onClosed()
            this.$emit('input', false)
            this.$message.success('保存成功')
            this.resetData()
          })
          .finally(() => {
            this.saveLoading = false
          })
      }
    },
    updateModule () {
      //模块组也是一个模板, 模块组和模块共用一个设置面板,通过样式过滤区别
      this.saveLoading = true
      let cloneData = JSON.parse(JSON.stringify(this.valueData))
      groupService
        .updateGroup(cloneData)
        .then(() => {
          this.$message.success('设置成功')
          this.resetData()
          // 退出模块组编辑时，将面板tab 切换成”模块组“
          let originData = this.$store.state.templateGroup.globalModuleItem
          Object.assign(originData, cloneData)
          this.$store.commit('templateGroup/set_global_module', originData)
          this.$store.commit('templateGroup/toggle_global_modal_dialog', false)
          this.$store.commit('templateGroup/set_attr_tab', '3')
        })
        .finally(() => {
          this.saveLoading = false
        })
    },
    resetData () {
      this.$store.commit('templateGroup/set_selected_item', null)
      this.$store.commit('templateGroup/clear_multi_img')
      this.$store.commit('templateGroup/set_bg_item', null)
      this.pageBgItem = null
      this.parentMap = {}
      this.missingFontFamilyList = []
      this.moduleList = []
    },
    onEditorItemClick (item, parent, ev) {
      this.eventBus.$emit('setCurrentNode', item.id, this.treeClick)
      /** 图片多选处理 start **/
      if (ev && item.type === 'img') {
        let dataList = this.$store.state.templateGroup.multiImgItems
        if (ev.ctrlKey || ev.metaKey) {
          this.$store.commit('templateGroup/add_multi_img', item)
        } else if (dataList.length > 0) {
          this.$store.commit('templateGroup/clear_multi_img')
        }
        if (dataList.length > 1) {
          return
        }
      }
      this.setSelectedItem(item)
      if (item.type) {
        this.$store.commit(
          'templateGroup/set_attr_tab',
          item.type === 'img' ? '2' : '1'
        )
      }
    },
    setSelectedItem (item) {
      this.$store.commit('templateGroup/set_selected_item', item)
    },
    onItemClick (item) {
      // console.log('onItemClick', item)
      if (item === null) {
        this.clearSelectedItem()
        return
      }
      if (this.selectedItem !== item) {
        // 取消移动文本状态
        let parent = this.parentMap[item.id]
        this.treeClick = true
        this.$refs.screenshotDom._triggerItemClick(item, parent)
        this.treeClick = false
      }
    },
    clearSelectedItem () {
      this.$store.commit('templateGroup/set_selected_item', null)
      this.eventBus.$emit('_triggerClearItem')
    },
    onKeydown (e) {
      if (e.code === 'Escape') {
        // esc
        this.clearSelectedItem()
      } else {
        this.textEvent(e)
      }
    },
    textEvent (e) {
      let item = this.$store.state.templateGroup.selectedItem
      if (item && item.type === 'text') {
        switch (e.code) {
          case 'ArrowUp':
            e.preventDefault()
            item.top = +item.top - 1
            item.bottom = item.top + +item.height
            break
          case 'ArrowDown':
            e.preventDefault()
            item.top = +item.top + 1
            item.bottom = item.top + +item.height
            break
          case 'ArrowLeft':
            e.preventDefault()
            item.left = +item.left - 1
            item.right = item.left + +item.width
            break
          case 'ArrowRight':
            e.preventDefault()
            item.left = +item.left + 1
            item.right = item.left + +item.width
            break
        }
        item.originData = item.originData ? item.originData : {}
        item.originData.left = item.left
        item.originData.top = item.top
        item.originData.bottom = item.bottom
        item.originData.right = item.right
      }
    },
    onCloseDialog () {
      this.missingFontVisible = false 
      this.onClosed()
      if (this.global) {
        // 退出模块组编辑时，将面板tab 切换成”模块组“
        this.$store.commit('templateGroup/set_attr_tab', '3')
      }
      this.resetData()
      if (this.global) {
        this.$store.commit('templateGroup/set_global_module', null)
        this.$store.commit('templateGroup/toggle_global_modal_dialog', false)
      } else {
        this.$emit('input', false)
      }
    },
    onConfirmDialog () {
      if (this.global) {
        this.updateModule()
      } else {
        this.updateTemplate()
      }
    },
    onReset () {
      this.$confirm('确认还原到模板首次上传时的数据？', '确认信息', {
        distinguishCancelAndClose: true
      })
        .then(() => {
          this.resetLoading = true
          let json = this.valueData.json
          if (json.originData) {
            let cloneTemplate = JSON.parse(JSON.stringify(this.valueData))
            cloneTemplate.json = JSON.parse(JSON.stringify(json.originData))
            cloneTemplate.json.originData = JSON.parse(
              JSON.stringify(cloneTemplate.json)
            )
            this.initData(cloneTemplate)
          }
          this.refreshTplKey += 1
          this.$store.commit('templateGroup/set_selected_item', null)
          this.$message({
            type: 'success',
            message: '还原成功'
          })
        })
        .finally(action => {
          this.resetLoading = false
        })
    },
    onEditorClick (ev) {
      // 点击组件外其它区域时，不触发父级click事件
      ev.stopPropagation()
    },
    onOpen () {
      // 记录操作日志
      if (!this.global && this.value) {
        this.userActionStartTime = moment(new Date()).format(
          'YYYY-MM-DD HH:mm:ss'
        ) // 记录pv开始时间
        this.saveUserAction(
          this.ActionType.templateConfig.name.key,
          this.ActionType.page.enter.key,
          this.data.type,
          this.data.id,
          null,
          this.userActionStartTime
        )
      }
    },
    onClosed () {
      if (!this.global && this.value) {
        let endTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
        this.saveUserAction(
          this.ActionType.templateConfig.name.key,
          this.ActionType.page.leave.key,
          this.data.type,
          this.data.id,
          null,
          this.userActionStartTime,
          endTime
        )
      }
    }
  }
}
</script>
<style lang="scss">
@import 'attr-dialog';
</style>
